import { CategoryType } from '@rocksoft/settings-sdk';

export interface DeviceLinkCategory {
  id: string;
  categoryType: CategoryType;
  humanId: string;
  displayName?: string;
  parentCategoryId?: string;
}

export interface DeviceLinkSelection {
  locationCategoryId?: string;
  categoryType?: CategoryType;
  categoryId?: string;
}

export function categoryTypeLabel(type: string): string {
  return type === 'FrontDesk' ? 'Front desk' : type;
}

export function isDeviceLinkSelectionValid(
  selection: DeviceLinkSelection,
  locations: readonly DeviceLinkCategory[],
  children: readonly DeviceLinkCategory[]
): boolean {
  if (!locations.some((location) => location.id === selection.locationCategoryId)) {
    return false;
  }

  if (selection.categoryType === 'Location') {
    return selection.categoryId === selection.locationCategoryId;
  }

  return children.some(
    (category) =>
      category.parentCategoryId === selection.locationCategoryId &&
      category.categoryType === selection.categoryType &&
      category.id === selection.categoryId
  );
}
